import { Formik, Form } from "formik";
import { colors } from "app/popleads/components/ui-kit/colors";
import React, { useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import ExtensionInputGroup, { StyledToggleLabel } from "./ExtensionInputGroup";
import { useExtensionContext } from "../ExtensionContext";
import {
    dealMarketingTypesOptions,
    dealChannelTypesOptions,
    DEAL_WON,
    DEAL_LOST,
    DEAL_CANCELLED,
    publicTypes,
} from "../utils/constants";
import useCompanyData from "app/popleads/hooks/useCompanyData";
import { toast } from "react-toastify";
import useGetAllUnits from "app/popleads/hooks/useGetAllUnits";
import useGetCompanyConfigByKeys from "app/popleads/hooks/useGetCompanyConfigByKeys";
import { StyledItemContainer } from "./ExtensionViewDeal";
import Toggle from "app/popleads/components/ui-kit/Toggle";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import useActivityPreview from "app/popleads/hooks/useActivityPreview";
import { getPartnerUserIdFromName } from "../utils/deal-utils";
import { post } from "app/popleads/networking/RequestService";

export const StyledLabel = styled.label`
    display: block;
    font-size: 12px;
    color: ${colors.neutral[600]};
    margin-bottom: 0px;

    ${(props) =>
        props.required &&
        `
    &:after {
      content: '*';
      color: #ff4d4f;
      margin-left: 4px;
    }
  `}

    ${(props) =>
        props.disabled &&
        `
    color: #999;
    cursor: not-allowed;
  `}
`;
const options = [
    { label: "Yes", value: "Yes", activeVariant: "success" },
    { label: "No", value: "No", activeVariant: "neutral" },
];
const ExtensionEditDeal = () => {
    const { setDealObject, dealObject, setIsDealEditing, selectedDeal, isInhouseTypes } = useExtensionContext();
    const { companyUsers } = useCompanyData();
    const { departments } = useGetAllUnits();
    const { checkCertificateNameCondition } = useGetCompanyConfigByKeys();
    const certificateInputShow = checkCertificateNameCondition(selectedDeal.campaignType);

    const fetchQuery = async (inputValue, page) => {
        const requestObj = {
            fn: "getAccountSuggestions",
            accountName: inputValue ? inputValue : dealObject.accountName,
            page: page,
            pageSize: 100,
        };

        try {
            const response = await post(requestObj);
            const data = response.data;
            const options = data?.accounts?.map((item) => {
                return {
                    value: item.accountName,
                    label: item.accountName,
                };
            });

            return {
                options,
                hasMore: data.totalCount ? page * 100 < data.totalCount : false,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: 1,
                },
            };
        }
    };

    const loadOptions = (inputValue, _, { page }) =>
        new Promise((resolve) => {
            const options = fetchQuery(inputValue, page);
            resolve(options);
        });
    const partnerOptions = useMemo(() => {
        return companyUsers.map((user) => ({
            label: user.name,
            value: user.id,
        }));
    }, [companyUsers]);
    useEffect(() => {
        return () => {
            setIsDealEditing(false);
        };
    }, []);
    useEffect(() => {
        if (selectedDeal) {
            const updatedDeal = {
                ...selectedDeal,
                kapanmaTarihi: selectedDeal.kapanmaTarihi,
                channelType: selectedDeal.dealTypeChannel || "",
                unitName: selectedDeal.unitName || "",
                partnerName: selectedDeal.partnerName || "",
                partnerUserId: selectedDeal.partnerUserId || getPartnerUserIdFromName(selectedDeal, companyUsers),
                certificateName: selectedDeal.certificateName || "",
                certificateSurname: selectedDeal.certificateLastName || "",
            };
            setDealObject(updatedDeal);
        }
    }, [companyUsers, selectedDeal]);
    const validateField = (fieldName, value, dealObject) => {
        switch (fieldName) {
            case "amount":
                // if (!value) {
                //     toast.warning("You need to enter the amount first");
                //     return true;
                // }
                // if (isNaN(value) || value <= 0) {
                //     toast.warning("Amount must be a positive number");
                //     return false;
                // }
                break;
            case "closingDate":
                if (!value && [DEAL_WON, DEAL_LOST, DEAL_CANCELLED].includes(dealObject.status)) {
                    toast.warning("Please choose a closing date");
                    return false;
                }
                break;
            case "type":
                if (!value && dealObject.status === DEAL_WON) {
                    toast.warning("You need to enter the type first");
                    return false;
                }
                break;
            case "channelType":
                if (
                    !value &&
                    ["Marketing", "Marketing Cross Sale"].includes(dealObject.type) &&
                    dealObject.status === DEAL_WON
                ) {
                    toast.warning("Please select marketing channel");
                    return false;
                }
                break;
            // case "certificateName":
            // case "certificateSurname":
            //     if (!value && publicTypes.includes(dealObject.dealCampaignType) && dealObject.status === DEAL_WON) {
            //         toast.warning(
            //             `Please provide a certificate ${fieldName === "certificateName" ? "name" : "surname"}`
            //         );
            //         return false;
            //     }
            //break;
            default:
                return true;
        }
        return true;
    };

    const handleInputChange = (field, value) => {
        if (validateField(field, value)) {
            const newDealObject = { ...dealObject, [field]: value };
            setDealObject(newDealObject);
        }
    };

    const [vatIncludes, setVatIncludes] = useState(dealObject?.vatIncludes === 1 ? "Yes" : "No");
    const [selfInvestment, setSelfInvestment] = useState(dealObject?.isSelfInvestment === 1 ? "Yes" : "No");
    const isDealPublicType = publicTypes.includes(dealObject.dealCampaignType) && dealObject.durum === DEAL_WON;
    const inConsultingType =
        dealObject.dealCampaignType === "Consulting" ||
        dealObject.dealCampaignType === "Coaching" ||
        dealObject.dealCampaignType === "E-Learning" ||
        dealObject.dealCampaignType === "EdTech";
    const dealActivityId = dealObject.activityId > 0;

    const { getActivityPreview } = useActivityPreview();
    const [activityPreview, setActivityPreview] = useState(null);

    useEffect(() => {
        if (dealObject.activityId) {
            getActivityPreview(dealObject.activityId).then((data) => {
                setActivityPreview(data.activity);
            });
        }
    }, [dealObject.activityId]);

    let courseNameLabel = "";
    let newCourseNameLabel = "";
    if (dealObject.dealCampaignType === "E-Learning" || dealObject.dealCampaignType === "EdTech") {
        courseNameLabel = "E-Learning Bundles";
        newCourseNameLabel = "New E-Learning Bundles";
    } else if (dealObject.dealCampaignType === "Consulting") {
        courseNameLabel = "Type of Consulting";
        newCourseNameLabel = "New Consulting Type";
    } else if (dealObject.dealCampaignType === "Coaching") {
        courseNameLabel = "Type of Coaching";
        newCourseNameLabel = "New Coaching Type";
    } else {
        courseNameLabel = "Course Name";
        newCourseNameLabel = "New Course Name";
    }
    const courseNameOptions = [
        ...(activityPreview?.topicList || []).map((item) => ({
            label: item.topicName,
            value: item.topicName,
        })),
        { label: "Type a new " + courseNameLabel, value: "newCourseName" },
    ];

    return (
        <Formik initialValues={dealObject}>
            {() => (
                <Form style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label="Deal Name"
                        type="input"
                        value={dealObject.ad}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("ad", value);
                        }}
                        placeholder="Please enter deal name"
                    />
                    <ExtensionInputGroup
                        variant="l3rnTech"
                        key={"single-select"}
                        placeholder={"Add Account"}
                        label="Account Name"
                        type="select"
                        isClearable={true}
                        isSearchable={true}
                        isCreatable={true}
                        isMulti={false}
                        loadOptions={loadOptions}
                        additional={{ page: 1 }}
                        value={{ label: dealObject.accountName, value: dealObject.accountName }}
                        onChange={(selected) => {
                            handleInputChange("accountName", selected ? selected.value : "");
                            if (selected) {
                                setDealObject({
                                    ...dealObject,
                                    accountName: selected.label,
                                });
                            } else {
                                setDealObject({ ...dealObject, accountName: "" });
                            }
                        }}
                    />
                    {!dealActivityId && (
                        <ExtensionCampaignSearchInput
                            optionClick={(value) => {
                                handleInputChange("etiketId", value?.id || "");
                                setDealObject({
                                    ...dealObject,
                                    etiketId: value?.id || "",
                                    campaign: value,
                                });
                            }}
                            value={dealObject.campaign}
                            label="Campaign Name"
                        />
                    )}

                    {dealObject.durum === DEAL_WON &&
                        (isInhouseTypes(dealObject.dealCampaignType) || inConsultingType) && (
                            <>
                                <ExtensionInputGroup
                                    variant="l3rnTech"
                                    label={courseNameLabel}
                                    type="select"
                                    inpType="text"
                                    onChange={(selected) => {
                                        handleInputChange("courseName", selected.value);
                                    }}
                                    options={courseNameOptions}
                                    value={
                                        dealObject.courseName
                                            ? dealObject.courseName === "newCourseName"
                                                ? { label: "Type a new " + courseNameLabel, value: "newCourseName" }
                                                : { label: dealObject.courseName, value: dealObject.courseName }
                                            : ""
                                    }
                                    placeholder={`Select ${courseNameLabel}`}
                                />

                                {dealObject?.courseName === "newCourseName" && (
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label={`New ${courseNameLabel}`}
                                        type="input"
                                        inpType="text"
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("newCourseName", value);
                                        }}
                                        value={dealObject.newCourseName}
                                        placeholder={`Enter ${newCourseNameLabel}`}
                                    />
                                )}
                            </>
                        )}

                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label={`${isInhouseTypes(dealObject.dealCampaignType) ? "Amount USD" : "Unit Amount USD"}`}
                        type="input"
                        inpType="number"
                        leftIcon="dollar-sign"
                        value={dealObject.amount}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("amount", value);
                        }}
                        minLength={1}
                        placeholder={`Please enter ${
                            isInhouseTypes(dealObject.dealCampaignType) ? "amount" : "unit amount"
                        }`}
                    />

                    {!isInhouseTypes(dealObject.dealCampaignType) && (
                        <div>
                            <StyledLabel>Number of Units</StyledLabel>
                            <div style={{ display: "flex", gap: "16px", marginTop: "4px" }}>
                                <ButtonWithText
                                    icon="remove"
                                    onClick={() => {
                                        const currentValue = Number(dealObject.units) || 1;

                                        if (currentValue > 1) {
                                            handleInputChange("units", currentValue - 1);
                                        }
                                    }}
                                    iconType="material"
                                    variant="passive"
                                    buttonStyle="default"
                                    size="circle"
                                />
                                {dealObject.units}
                                <ButtonWithText
                                    icon="add"
                                    onClick={() => {
                                        const currentValue = Number(dealObject.units) || 0;
                                        handleInputChange("units", currentValue + 1);
                                    }}
                                    iconType="material"
                                    variant="l3rnTech"
                                    buttonStyle="default"
                                    size="circle"
                                />
                            </div>
                        </div>
                    )}

                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label="Paid Amount"
                        type="input"
                        disabled={true}
                        inpType="number"
                        leftIcon="dollar-sign"
                        value={dealObject.paidAmount}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("paidAmount", value);
                        }}
                        placeholder="Please enter paid amount"
                    />

                    {(dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) && (
                        <ExtensionInputGroup
                            variant="l3rnTech"
                            label="Closing Date"
                            type="date"
                            value={dealObject.closingDate || dealObject.kapanmaTarihi}
                            onChange={(date) => {
                                handleInputChange("closingDate", date);
                                handleInputChange("kapanmaTarihi", date);
                            }}
                            placeholder="Please select closing date"
                            noTimeSelection={true}
                        />
                    )}

                    {(dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) && (
                        <ExtensionInputGroup
                            variant="l3rnTech"
                            label="Type"
                            type="select"
                            options={dealMarketingTypesOptions}
                            value={dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""}
                            onChange={(selected) => {
                                handleInputChange("type", selected.value);
                                if (selected.value !== "Marketing" && selected.value !== "Marketing Cross Sale") {
                                    setDealObject((prevDealObject) => ({
                                        ...prevDealObject,
                                        dealTypeChannel: "",
                                        typeChannel: "",
                                        channelType: "",
                                    }));
                                }
                            }}
                            placeholder="Please select type"
                        />
                    )}

                    {(dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) &&
                        (dealObject.type === "Marketing" || dealObject.type === "Marketing Cross Sale") && (
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Marketing Channel"
                                type="select"
                                options={dealChannelTypesOptions}
                                value={
                                    dealObject.dealTypeChannel
                                        ? { label: dealObject.dealTypeChannel, value: dealObject.dealTypeChannel }
                                        : ""
                                }
                                onChange={(selected) => {
                                    setDealObject({
                                        ...dealObject,
                                        dealTypeChannel: selected.value,
                                        typeChannel: selected.value,
                                        channelType: selected.value,
                                    });
                                }}
                                placeholder="Please select marketing channel"
                            />
                        )}

                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label="Department"
                        type="select"
                        options={departments}
                        onChange={(selected) => {
                            if (selected) {
                                const newDealObject = { ...dealObject };
                                newDealObject.unitId = selected.value;
                                newDealObject.unitName = selected.label;
                                setDealObject(newDealObject);
                            }
                        }}
                        value={
                            dealObject?.unitName
                                ? {
                                      label: dealObject?.unitName,
                                      value: dealObject?.unitId,
                                  }
                                : ""
                        }
                        placeholder="Please select department"
                    />

                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label="Partner"
                        type="select"
                        options={partnerOptions}
                        onChange={(selected) => {
                            if (selected) {
                                setDealObject({
                                    ...dealObject,
                                    partnerName: selected.label,
                                    partnerUserId: selected.value,
                                });
                            } else {
                                setDealObject({ ...dealObject, partnerName: "", partnerUserId: "" });
                            }
                        }}
                        value={
                            dealObject?.partnerName
                                ? {
                                      label: dealObject?.partnerName,
                                      value: dealObject?.partnerUserId,
                                  }
                                : ""
                        }
                        placeholder="Please select partner"
                        isClearable={true}
                    />
                    <StyledItemContainer>
                        <StyledToggleLabel>Vat Included</StyledToggleLabel>
                        <Toggle
                            variant="l3rnTech"
                            size="small"
                            setSelected={(value) => {
                                handleInputChange("vatIncludes", value === "Yes" ? 1 : 0);
                                setVatIncludes(value);
                            }}
                            selected={vatIncludes}
                            options={options}
                        />
                    </StyledItemContainer>
                    {isDealPublicType && (
                        <StyledItemContainer>
                            <StyledToggleLabel>Self Investment</StyledToggleLabel>
                            <Toggle
                                variant="l3rnTech"
                                size="small"
                                setSelected={(value) => {
                                    handleInputChange("isSelfInvestment", value === "Yes" ? 1 : 0);
                                    setSelfInvestment(value);
                                }}
                                selected={selfInvestment}
                                options={options}
                            />
                        </StyledItemContainer>
                    )}
                    {(dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) &&
                        certificateInputShow &&
                        !dealActivityId && (
                            <>
                                <ExtensionInputGroup
                                    variant="l3rnTech"
                                    label="Certificate Name"
                                    type="input"
                                    value={dealObject.certificateName}
                                    onChange={(e) => {
                                        const value = e.target ? e.target.value : e;
                                        handleInputChange("certificateName", value);
                                    }}
                                    placeholder="Please enter certificate name"
                                />

                                <ExtensionInputGroup
                                    variant="l3rnTech"
                                    label="Certificate Lastname"
                                    type="input"
                                    value={dealObject.certificateLastName}
                                    onChange={(e) => {
                                        const value = e.target ? e.target.value : e;
                                        handleInputChange("certificateLastName", value);
                                    }}
                                    placeholder="Please enter certificate lastname"
                                />
                            </>
                        )}
                </Form>
            )}
        </Formik>
    );
};

export default ExtensionEditDeal;
